import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronRight, ChevronLeft } from 'lucide-react';
import './HeroCarousel.css';

export default function HeroCarousel({ slides }) {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            nextSlide();
        }, 5000); // 5 seconds per slide
        return () => clearInterval(timer);
    }, [currentIndex]);

    const nextSlide = () => {
        setCurrentIndex((prev) => (prev + 1) % slides.length);
    };

    const prevSlide = () => {
        setCurrentIndex((prev) => (prev - 1 + slides.length) % slides.length);
    };

    return (
        <div className="hero-carousel-container">
            <div className="carousel-frame">
                <AnimatePresence mode="wait">
                    <motion.div
                        key={currentIndex}
                        className="carousel-slide"
                        initial={{ opacity: 0, scale: 1.05 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        <img
                            src={slides[currentIndex].image}
                            alt={slides[currentIndex].label}
                            className="carousel-image"
                        />
                        <div className="carousel-overlay">
                            <motion.div
                                className="carousel-text"
                                initial={{ y: 20, opacity: 0 }}
                                animate={{ y: 0, opacity: 1 }}
                                transition={{ delay: 0.3 }}
                            >
                                <h2>{slides[currentIndex].label}</h2>
                                <p>{slides[currentIndex].sublabel}</p>
                            </motion.div>
                        </div>
                    </motion.div>
                </AnimatePresence>

                {/* Progress Indicators */}
                <div className="carousel-indicators">
                    {slides.map((_, index) => (
                        <div
                            key={index}
                            className={`indicator ${index === currentIndex ? 'active' : ''}`}
                            onClick={() => setCurrentIndex(index)}
                        >
                            {index === currentIndex && (
                                <motion.div
                                    className="indicator-fill"
                                    layoutId="indicator"
                                    transition={{ duration: 0.3 }}
                                />
                            )}
                        </div>
                    ))}
                </div>

                {/* Arrows */}
                <button className="carousel-btn btn-prev" onClick={prevSlide} aria-label="Previous Slide">
                    <ChevronLeft size={24} />
                </button>
                <button className="carousel-btn btn-next" onClick={nextSlide} aria-label="Next Slide">
                    <ChevronRight size={24} />
                </button>
            </div>

            {/* Context Card - Floating Element */}
            <motion.div
                className="carousel-context-card glass-panel"
                key={`ctx-${currentIndex}`}
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
            >
                <div className="context-icon-box">
                    <div className="pulse-dot"></div>
                </div>
                <div className="context-info">
                    <span className="context-label">Priority #{currentIndex + 1}</span>
                    <strong>{slides[currentIndex].label}</strong>
                </div>
            </motion.div>
        </div>
    );
}
